<p>color-picker works!</p>
